import { render, staticRenderFns } from "./DialogAddPartner.vue?vue&type=template&id=b2d8f4f6&scoped=true"
import script from "./DialogAddPartner.vue?vue&type=script&lang=js"
export * from "./DialogAddPartner.vue?vue&type=script&lang=js"
import style0 from "./DialogAddPartner.vue?vue&type=style&index=0&id=b2d8f4f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d8f4f6",
  null
  
)

export default component.exports